module.exports = __webpack_public_path__ + "img/Clerk.72b9d12b.jpg";